import { type RovoConnectorState } from '../useRovoConfigStore';

/**
 * Builds a connectors record ordered by each connector's final `friendlyName`.
 *
 * Sorts case-insensitively (locale-aware) with the `source` slug as a
 * locale-neutral tie-breaker, then inserts entries in that order — JS preserves
 * string-key insertion order, so iterating the result yields sorted connectors.
 */
export const sortConnectorsByFriendlyName = (
	entries: RovoConnectorState[],
): Record<string, RovoConnectorState> => {
	const sorted = [...entries].sort(
		(a, b) =>
			a.friendlyName.localeCompare(b.friendlyName, undefined, { sensitivity: 'base' }) ||
			(a.source < b.source ? -1 : a.source > b.source ? 1 : 0),
	);

	const connectors: Record<string, RovoConnectorState> = {};
	for (const entry of sorted) {
		connectors[entry.source] = entry;
	}
	return connectors;
};
